// load brace
var ace = require('brace');

// load required ace modules
require('brace/mode/json');
require('brace/ext/searchbox');

module.exports = ace;



//////////////////
// WEBPACK FOOTER
// ./~/jsoneditor/src/js/ace/index.js
// module id = 67
// module chunks = 0